import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { IncidentActivityService } from './incident-activity.service';
import { IncidentActivityState } from './incident-activity.state';

@NgModule({
  imports: [NgxsModule.forFeature([IncidentActivityState])],
  providers: [IncidentActivityService],
})
export class IncidentActivityStateModule {}
